import type { VoidComponent } from "solid-js";
import { createMemo } from "solid-js";

export type TextLinkProps = {
  href: string;
  label: string;
  classes?: string;
  isExternal?: boolean;
};

const TextLink: VoidComponent<TextLinkProps> = (props) => {
  const propsWhenExternal = createMemo(() =>
    (props?.isExternal ?? false)
      ? {
          target: "_blank",
          rel: "noopener noreferrer",
        }
      : {},
  );

  return (
    <a
      classList={{
        "text-link underline hover:text-link-hover focus-visible:outline-default": true,
        [props.classes ?? ""]: true,
      }}
      href={props.href}
      {...propsWhenExternal()}
    >
      {props.label}
    </a>
  );
};

export default TextLink;
